export const API_URL = "https://api.marketpro.ch/api/";
export const ASSET_DOMAIN = "https://api.marketpro.ch";
export const STRIPE_PUBLIC = "pk_test_8RriRtkXqg52CWRbSPpQtoyG00xn3qOkW2"
export default {}
